export default {
    cause_294: 'All causes',
    cause_295: 'Communicable, maternal, neonatal, and nutritional diseases',
    cause_297: 'Tuberculosis',
    cause_298: 'HIV/AIDS',
    cause_300: 'HIV/AIDS resulting in other diseases',
    cause_302: 'Diarrheal diseases',
    cause_319: 'Typhoid fever',
    cause_320: 'Paratyphoid fever',
    cause_321: 'Other intestinal infectious diseases',
    cause_322: 'Lower respiratory infections',
    cause_328: 'Upper respiratory infections',
    cause_329: 'Otitis media',
    cause_332: 'Meningitis',
    cause_333: 'Pneumococcal meningitis',
    cause_334: 'H influenzae type B meningitis',
    cause_335: 'Meningococcal meningitis',
    cause_336: 'Other meningitis',
    cause_337: 'Encephalitis',
    cause_338: 'Diphtheria',
    cause_339: 'Whooping cough',
    cause_340: 'Tetanus',
    cause_341: 'Measles',
    cause_342: 'Varicella and herpes zoster',
    cause_344: 'Neglected tropical diseases and malaria',
    cause_345: 'Malaria',
    cause_346: 'Chagas disease',
    cause_347: 'Leishmaniasis',
    cause_348: 'Visceral leishmaniasis',
    cause_349: 'Cutaneous and mucocutaneous leishmaniasis',
    cause_350: 'African trypanosomiasis',
    cause_351: 'Schistosomiasis',
    cause_352: 'Cysticercosis',
    cause_353: 'Cystic echinococcosis',
    cause_354: 'Lymphatic filariasis',
    cause_355: 'Onchocerciasis',
    cause_356: 'Trachoma',
    cause_357: 'Dengue',
    cause_358: 'Yellow fever',
    cause_359: 'Rabies',
    cause_360: 'Intestinal nematode infections',
    cause_361: 'Ascariasis',
    cause_362: 'Trichuriasis',
    cause_363: 'Hookworm disease',
    cause_364: 'Food-borne trematodiases',
    cause_365: 'Other neglected tropical diseases',
    cause_366: 'Maternal disorders',
    cause_367: 'Maternal hemorrhage',
    cause_368: 'Maternal sepsis and other maternal infections',
    cause_369: 'Maternal hypertensive disorders',
    cause_370: 'Maternal obstructed labor and uterine rupture',
    cause_374: 'Ectopic pregnancy',
    cause_375: 'Indirect maternal deaths',
    cause_376: 'Late maternal deaths',
    cause_379: 'Other maternal disorders',
    cause_380: 'Neonatal disorders',
    cause_381: 'Neonatal preterm birth',
    cause_382: 'Neonatal encephalopathy due to birth asphyxia and trauma',
    cause_383: 'Neonatal sepsis and other neonatal infections',
    cause_384: 'Hemolytic disease and other neonatal jaundice',
    cause_385: 'Other neonatal disorders',
    cause_386: 'Nutritional deficiencies',
    cause_387: 'Protein-energy malnutrition',
    cause_388: 'Iodine deficiency',
    cause_389: 'Vitamin A deficiency',
    cause_390: 'Dietary iron deficiency',
    cause_391: 'Other nutritional deficiencies',
    cause_393: 'Sexually transmitted infections excluding HIV',
    cause_394: 'Syphilis',
    cause_395: 'Chlamydial infection',
    cause_396: 'Gonococcal infection',
    cause_397: 'Trichomoniasis',
    cause_398: 'Genital herpes',
    cause_399: 'Other sexually transmitted infections',
    cause_400: 'Acute hepatitis',
    cause_401: 'Acute hepatitis A',
    cause_402: 'Acute hepatitis B',
    cause_403: 'Acute hepatitis C',
    cause_404: 'Acute hepatitis E',
    cause_405: 'Leprosy',
    cause_408: 'Other unspecified infectious diseases',
    cause_409: 'Non-communicable diseases',
    cause_410: 'Neoplasms',
    cause_411: 'Esophageal cancer',
    cause_414: 'Stomach cancer',
    cause_417: 'Liver cancer',
    cause_418: 'Liver cancer due to hepatitis B',
    cause_419: 'Liver cancer due to hepatitis C',
    cause_420: 'Liver cancer due to alcohol use',
    cause_421: 'Liver cancer due to other causes',
    cause_423: 'Larynx cancer',
    cause_426: 'Tracheal, bronchus, and lung cancer',
    cause_429: 'Breast cancer',
    cause_432: 'Cervical cancer',
    cause_435: 'Uterine cancer',
    cause_438: 'Prostate cancer',
    cause_441: 'Colon and rectum cancer',
    cause_444: 'Lip and oral cavity cancer',
    cause_447: 'Nasopharynx cancer',
    cause_450: 'Other pharynx cancer',
    cause_453: 'Gallbladder and biliary tract cancer',
    cause_456: 'Pancreatic cancer',
    cause_459: 'Malignant skin melanoma',
    cause_462: 'Non-melanoma skin cancer',
    cause_465: 'Ovarian cancer',
    cause_468: 'Testicular cancer',
    cause_471: 'Kidney cancer',
    cause_474: 'Bladder cancer',
    cause_477: 'Brain and central nervous system cancer',
    cause_480: 'Thyroid cancer',
    cause_483: 'Mesothelioma',
    cause_484: 'Hodgkin lymphoma',
    cause_485: 'Non-Hodgkin lymphoma',
    cause_486: 'Multiple myeloma',
    cause_487: 'Leukemia',
    cause_489: 'Other malignant neoplasms',
    cause_490: 'Other neoplasms',
    cause_491: 'Cardiovascular diseases',
    cause_492: 'Rheumatic heart disease',
    cause_493: 'Ischemic heart disease',
    cause_494: 'Stroke',
    cause_495: 'Ischemic stroke',
    cause_496: 'Intracerebral hemorrhage',
    cause_497: 'Subarachnoid hemorrhage',
    cause_498: 'Hypertensive heart disease',
    cause_499: 'Cardiomyopathy and myocarditis',
    cause_500: 'Atrial fibrillation and flutter',
    cause_501: 'Aortic aneurysm',
    cause_502: 'Peripheral artery disease',
    cause_503: 'Endocarditis',
    cause_504: 'Non-rheumatic valvular heart disease',
    cause_507: 'Other cardiovascular and circulatory diseases',
    cause_508: 'Chronic respiratory diseases',
    cause_509: 'Chronic obstructive pulmonary disease',
    cause_510: 'Pneumoconiosis',
    cause_511: 'Silicosis',
    cause_512: 'Asbestosis',
    cause_513: 'Coal workers pneumoconiosis',
    cause_514: 'Other pneumoconiosis',
    cause_515: 'Asthma',
    cause_516: 'Interstitial lung disease and pulmonary sarcoidosis',
    cause_520: 'Other chronic respiratory diseases',
    cause_521: 'Cirrhosis and other chronic liver diseases',
    cause_522: 'Cirrhosis and other chronic liver diseases due to hepatitis B',
    cause_523: 'Cirrhosis and other chronic liver diseases due to hepatitis C',
    cause_524: 'Cirrhosis and other chronic liver diseases due to alcohol use',
    cause_525: 'Cirrhosis and other chronic liver diseases due to other causes',
    cause_526: 'Digestive diseases',
    cause_527: 'Peptic ulcer disease',
    cause_528: 'Gastritis and duodenitis',
    cause_529: 'Appendicitis',
    cause_530: 'Paralytic ileus and intestinal obstruction',
    cause_531: 'Inguinal, femoral, and abdominal hernia',
    cause_532: 'Inflammatory bowel disease',
    cause_533: 'Vascular intestinal disorders',
    cause_534: 'Gallbladder and biliary diseases',
    cause_535: 'Pancreatitis',
    cause_536: 'Gastroesophageal reflux disease',
    cause_537: 'Diverticular disease of intestines',
    cause_541: 'Other digestive diseases',
    cause_542: 'Neurological disorders',
    cause_543: "Alzheimer's disease and other dementias",
    cause_544: "Parkinson's disease",
    cause_545: 'Idiopathic epilepsy',
    cause_546: 'Multiple sclerosis',
    cause_547: 'Migraine',
    cause_548: 'Tension-type headache',
    cause_554: 'Motor neuron disease',
    cause_557: 'Other neurological disorders',
    cause_558: 'Mental disorders',
    cause_559: 'Schizophrenia',
    cause_560: 'Alcohol use disorders',
    cause_561: 'Drug use disorders',
    cause_562: 'Opioid use disorders',
    cause_563: 'Cocaine use disorders',
    cause_564: 'Amphetamine use disorders',
    cause_565: 'Cannabis use disorders',
    cause_566: 'Other drug use disorders',
    cause_567: 'Depressive disorders',
    cause_568: 'Major depressive disorder',
    cause_569: 'Dysthymia',
    cause_570: 'Bipolar disorder',
    cause_571: 'Anxiety disorders',
    cause_572: 'Eating disorders',
    cause_573: 'Anorexia nervosa',
    cause_574: 'Bulimia nervosa',
    cause_575: 'Autism spectrum disorders',
    cause_578: 'Attention-deficit/hyperactivity disorder',
    cause_579: 'Conduct disorder',
    cause_582: 'Idiopathic developmental intellectual disability',
    cause_585: 'Other mental disorders',
    cause_587: 'Diabetes mellitus',
    cause_588: 'Acute glomerulonephritis',
    cause_589: 'Chronic kidney disease',
    cause_591: 'Chronic kidney disease due to hypertension',
    cause_592: 'Chronic kidney disease due to glomerulonephritis',
    cause_593: 'Chronic kidney disease due to other and unspecified causes',
    cause_594: 'Urinary diseases and male infertility',
    cause_595: 'Interstitial nephritis and urinary tract infections',
    cause_596: 'Urolithiasis',
    cause_597: 'Benign prostatic hyperplasia',
    cause_598: 'Male infertility',
    cause_602: 'Other urinary diseases',
    cause_603: 'Gynecological diseases',
    cause_604: 'Uterine fibroids',
    cause_605: 'Polycystic ovarian syndrome',
    cause_606: 'Female infertility',
    cause_607: 'Endometriosis',
    cause_608: 'Genital prolapse',
    cause_609: 'Premenstrual syndrome',
    cause_612: 'Other gynecological diseases',
    cause_613: 'Hemoglobinopathies and hemolytic anemias',
    cause_614: 'Thalassemias',
    cause_615: 'Sickle cell disorders',
    cause_616: 'G6PD deficiency',
    cause_618: 'Other hemoglobinopathies and hemolytic anemias',
    cause_619: 'Endocrine, metabolic, blood, and immune disorders',
    cause_625: 'Other endocrine, metabolic, blood, and immune disorders',
    cause_626: 'Musculoskeletal disorders',
    cause_627: 'Rheumatoid arthritis',
    cause_628: 'Osteoarthritis',
    cause_630: 'Low back pain',
    cause_631: 'Neck pain',
    cause_632: 'Gout',
    cause_639: 'Other musculoskeletal disorders',
    cause_640: 'Other non-communicable diseases',
    cause_641: 'Congenital birth defects',
    cause_642: 'Neural tube defects',
    cause_643: 'Congenital heart anomalies',
    cause_644: 'Orofacial clefts',
    cause_645: 'Down syndrome',
    cause_646: 'Turner syndrome',
    cause_647: 'Klinefelter syndrome',
    cause_648: 'Other chromosomal abnormalities',
    cause_649: 'Congenital musculoskeletal and limb anomalies',
    cause_650: 'Urogenital congenital anomalies',
    cause_651: 'Digestive congenital anomalies',
    cause_652: 'Other congenital birth defects',
    cause_653: 'Skin and subcutaneous diseases',
    cause_654: 'Dermatitis',
    cause_655: 'Psoriasis',
    cause_656: 'Cellulitis',
    cause_657: 'Pyoderma',
    cause_658: 'Scabies',
    cause_659: 'Fungal skin diseases',
    cause_660: 'Viral skin diseases',
    cause_661: 'Acne vulgaris',
    cause_662: 'Alopecia areata',
    cause_663: 'Pruritus',
    cause_664: 'Urticaria',
    cause_665: 'Decubitus ulcer',
    cause_668: 'Other skin and subcutaneous diseases',
    cause_669: 'Sense organ diseases',
    cause_670: 'Glaucoma',
    cause_671: 'Cataract',
    cause_672: 'Age-related macular degeneration',
    cause_674: 'Age-related and other hearing loss',
    cause_675: 'Other vision loss',
    cause_679: 'Other sense organ diseases',
    cause_680: 'Oral disorders',
    cause_681: 'Caries of deciduous teeth',
    cause_682: 'Caries of permanent teeth',
    cause_683: 'Periodontal diseases',
    cause_684: 'Edentulism and severe tooth loss',
    cause_685: 'Other oral disorders',
    cause_686: 'Sudden infant death syndrome',
    cause_687: 'Injuries',
    cause_688: 'Transport injuries',
    cause_689: 'Road injuries',
    cause_690: 'Pedestrian road injuries',
    cause_691: 'Cyclist road injuries',
    cause_692: 'Motorcyclist road injuries',
    cause_693: 'Motor vehicle road injuries',
    cause_694: 'Other road injuries',
    cause_695: 'Other transport injuries',
    cause_696: 'Unintentional injuries',
    cause_697: 'Falls',
    cause_698: 'Drowning',
    cause_699: 'Fire, heat, and hot substances',
    cause_700: 'Poisonings',
    cause_701: 'Poisoning by carbon monoxide',
    cause_703: 'Poisoning by other means',
    cause_704: 'Exposure to mechanical forces',
    cause_705: 'Unintentional firearm injuries',
    cause_707: 'Other exposure to mechanical forces',
    cause_708: 'Adverse effects of medical treatment',
    cause_709: 'Animal contact',
    cause_710: 'Venomous animal contact',
    cause_711: 'Non-venomous animal contact',
    cause_712: 'Foreign body',
    cause_713: 'Pulmonary aspiration and foreign body in airway',
    cause_714: 'Foreign body in eyes',
    cause_715: 'Foreign body in other body part',
    cause_716: 'Other unintentional injuries',
    cause_717: 'Self-harm and interpersonal violence',
    cause_718: 'Self-harm',
    cause_719: 'Self-harm by hanging, strangulation, and suffocation',
    cause_720: 'Self-harm by fire, heat, and hot substances',
    cause_721: 'Self-harm by firearm',
    cause_722: 'Self-harm by poisoning pesticides',
    cause_723: 'Self-harm by other specified means',
    cause_724: 'Interpersonal violence',
    cause_725: 'Physical violence by firearm',
    cause_726: 'Physical violence by sharp object',
    cause_727: 'Physical violence by other means',
    cause_729: 'Exposure to forces of nature',
    cause_741: 'Maternal deaths aggravated by HIV/AIDS',
    cause_837: 'Thalassemias trait',
    cause_838: 'Sickle cell trait',
    cause_839: 'G6PD trait',
    cause_842: 'Environmental heat and cold exposure',
    cause_843: 'Ebola',
    cause_845: 'Acute lymphoid leukemia',
    cause_846: 'Chronic lymphoid leukemia',
    cause_847: 'Acute myeloid leukemia',
    cause_848: 'Chronic myeloid leukemia',
    cause_849: 'Non-melanoma skin cancer (squamous-cell carcinoma)',
    cause_850: 'Non-melanoma skin cancer (basal-cell carcinoma)',
    cause_854: 'Executions and police conflict',
    cause_934: 'Drug-susceptible tuberculosis',
    cause_935: 'Zika virus',
    cause_936: 'Guinea worm disease',
    cause_938: 'Alcoholic cardiomyopathy',
    cause_940: 'Electrocution',
    cause_941: 'Sexual violence',
    cause_942: 'Myocarditis',
    cause_943: 'Other leukemia',
    cause_944: 'Other cardiomyopathy',
    cause_945: 'Conflict and terrorism',
    cause_946: 'Multidrug-resistant tuberculosis without extensive drug resistance',
    cause_947: 'Extensively drug-resistant tuberculosis',
    cause_948: 'HIV/AIDS - Drug-susceptible Tuberculosis',
    cause_949: 'HIV/AIDS - Multidrug-resistant Tuberculosis without extensive drug resistance',
    cause_950: 'HIV/AIDS - Extensively drug-resistant Tuberculosis',
    cause_954: 'Latent tuberculosis infection',
    cause_955: 'HIV/AIDS and sexually transmitted infections',
    cause_956: 'Respiratory infections and tuberculosis',
    cause_957: 'Enteric infections',
    cause_958: 'Typhoid and paratyphoid',
    cause_959: 'Invasive Non-typhoidal Salmonella (iNTS)',
    cause_961: 'Other infectious diseases',
    cause_962: 'Maternal and neonatal disorders',
    cause_964: 'Myelodysplastic, myeloproliferative, and other hematopoietic neoplasms',
    cause_965: 'Benign and in situ intestinal neoplasms',
    cause_966: 'Benign and in situ cervical and uterine neoplasms',
    cause_967: 'Other benign and in situ neoplasms',
    cause_968: 'Non-rheumatic calcific aortic valve disease',
    cause_969: 'Non-rheumatic degenerative mitral valve disease',
    cause_970: 'Other non-rheumatic valve diseases',
    cause_971: 'Cirrhosis and other chronic liver diseases due to NAFLD',
    cause_972: 'Headache disorders',
    cause_973: 'Substance use disorders',
    cause_974: 'Diabetes and kidney diseases',
    cause_975: 'Diabetes mellitus type 1',
    cause_976: 'Diabetes mellitus type 2',
    cause_977: 'Atopic dermatitis',
    cause_978: 'Contact dermatitis',
    cause_979: 'Seborrhoeic dermatitis',
    cause_980: 'Bacterial skin diseases',
    cause_981: 'Blindness and vision loss',
    cause_991: 'Non-malignant brain and other central nervous system neoplasms',
    cause_992: 'Upper digestive system diseases',
    cause_995: 'Maternal abortion and miscarriage',
    cause_996: 'Liver cancer due to NASH',
    cause_997: 'Chronic kidney disease due to diabetes mellitus type 1',
    cause_998: 'Chronic kidney disease due to diabetes mellitus type 2',
    cause_999: 'Refraction disorders',
    cause_1000: 'Near vision loss',
    cause_1004: 'Pulmonary Arterial Hypertension',
    cause_1005: 'Hepatoblastoma',
    cause_1006: 'Burkitt lymphoma',
    cause_1007: 'Other non-Hodgkin lymphoma',
    cause_1008: 'Eye cancer',
    cause_1009: 'Retinoblastoma',
    cause_1010: 'Other eye cancers',
    cause_1011: 'Soft tissue and other extraosseous sarcomas',
    cause_1012: 'Malignant neoplasm of bone and articular cartilage',
    cause_1013: 'Neuroblastoma and other peripheral nervous cell tumors',
    cause_1014: 'Osteoarthritis hip',
    cause_1015: 'Osteoarthritis knee',
    cause_1016: 'Osteoarthritis hand',
    cause_1017: 'Osteoarthritis other',
    cause_1021: 'Liver cancer due to other', // GBD 2019 same name as id 421
    cause_1022: 'Other malignant neoplasms', // GBD 2019 same name as id 489
    cause_1023: 'Other cardiovascular and circulatory diseases', // GBD 2019 same name as id 507
    cause_1024: 'Ulcerative colitis',
    cause_1025: "Crohn's disease",
    cause_1026: 'Total burden related to hepatitis B',
    cause_1027: 'Total burden related to hepatitis C',
    cause_1028: 'Total burden related to Non-alcoholic fatty liver disease (NAFLD)',
    cause_1029: 'Total cancers',
    cause_1032: 'Thyroid diseases',
    cause_1048: 'COVID-19',
    cause_1056: 'Other unintentional injuries',
    cause_1058: 'Other COVID-19 pandemic-related outcomes',
    cause_1059: 'Total Cancers excluding Non-melanoma skin cancer',
    cause_1111: 'Self-harm by non pesticide substance and gas',
    cause_1115: 'Other corneal opacities',
    cause_1118: 'Gestational diabetes',
    cause_1119: 'Peripartum Cardiomyopathy',
    cause_1160: 'Other direct maternal disorders',
    cause_1161: 'Other digestive diseases',
    cause_1163: 'Self-harm by other specified means',
    cause_1164: 'Other benign and in situ neoplasms',
    cause_10001: 'Newly diagnosed multiple myeloma (LoT 1)',
    cause_10002: 'Relapsed and refractory multiple myeloma',
    cause_10003: 'Multiple myeloma in first relapse (LoT 2)',
    cause_10006: 'Multiple myeloma in fourth or higher relapse (LoT 5)',
    cause_10004: 'Multiple myeloma in second relapse (LoT 3)',
    cause_10005: 'Multiple myeloma in third relapse (LoT 4)',

    cause_10007: 'Acute renal failure',
    cause_10008: 'Heart Failure',
    cause_10009: 'Lower extremity peripheral arterial disease',
    cause_10014: 'Treatment of hyperlipidemia',
    cause_10015: 'Treatment of hypertension',
    cause_10016: 'Treatment of obesity',
    cause_10024: 'CRM',

    cause_100001: 'All pathogens',
    cause_100002: 'Novel Flu',
    cause_100003: 'Novel Sars',

    cause_1100: 'All multiple myeloma',
    cause_1101: 'Multiple myeloma in first relapse (LoT 2)',
    cause_1102: 'Multiple myeloma in fourth or higher relapse (LoT 5)',
    cause_1103: 'Multiple myeloma in second relapse (LoT 3)',
    cause_1104: 'Multiple myeloma in third relapse (LoT 4)',
    cause_1105: 'Newly diagnosed multiple myeloma (LoT 1)',
    cause_1106: 'Relapsed and refractory multiple myeloma',

    cause_short_294: 'All causes',
    cause_short_295: 'Group I',
    cause_short_955: 'HIV/AIDS+STIs',
    cause_short_298: 'HIV',
    cause_short_948: 'Drug-Sus HIV-TB',
    cause_short_949: 'MDR-HIV-TB',
    cause_short_950: 'XDR-HIV-TB',
    cause_short_300: 'Oth HIV',
    cause_short_393: 'STI',
    cause_short_394: 'Syphilis',
    cause_short_395: 'Chlamydia',
    cause_short_396: 'Gonorrhea',
    cause_short_397: 'Trich',
    cause_short_398: 'Herpes',
    cause_short_399: 'Oth STI',
    cause_short_956: 'Resp+TB',
    cause_short_297: 'TB',
    cause_short_954: 'LTBI',
    cause_short_934: 'Drug-Sus TB',
    cause_short_946: 'MDR-TB',
    cause_short_947: 'XDR-TB',
    cause_short_322: 'LRI',
    cause_short_328: 'URI',
    cause_short_329: 'Otitis',
    cause_short_957: 'Enteric Infect',
    cause_short_302: 'Diarrhea',
    cause_short_958: 'Typh + Paratyph',
    cause_short_319: 'Typhoid',
    cause_short_320: 'Paratyph',
    cause_short_959: 'iNTS',
    cause_short_321: 'Oth Intest',
    cause_short_344: 'NTD+Malaria',
    cause_short_345: 'Malaria',
    cause_short_346: 'Chagas',
    cause_short_347: 'Leish',
    cause_short_348: 'Vis Leish',
    cause_short_349: 'Cut Leish',
    cause_short_350: 'Afr Tryp',
    cause_short_351: 'Schisto',
    cause_short_352: 'Cysticer',
    cause_short_353: 'Echino',
    cause_short_354: 'LF',
    cause_short_355: 'Oncho',
    cause_short_356: 'Trachoma',
    cause_short_357: 'Dengue',
    cause_short_358: 'Yellow Fev',
    cause_short_359: 'Rabies',
    cause_short_360: 'Nematode',
    cause_short_361: 'Ascaria',
    cause_short_362: 'Trichuria',
    cause_short_363: 'Hookworm',
    cause_short_364: 'FB Trema',
    cause_short_405: 'Leprosy',
    cause_short_843: 'Ebola',
    cause_short_935: 'Zika',
    cause_short_936: 'GWD',
    cause_short_365: 'Oth NTD',
    cause_short_961: 'Other+Diseases',
    cause_short_332: 'Meningitis',
    cause_short_337: 'Encepha',
    cause_short_338: 'Diphtheria',
    cause_short_339: 'Whooping',
    cause_short_340: 'Tetanus',
    cause_short_341: 'Measles',
    cause_short_342: 'Varicella',
    cause_short_400: 'Hep',
    cause_short_401: 'Hep A',
    cause_short_402: 'Hep B',
    cause_short_403: 'Hep C',
    cause_short_404: 'Hep E',
    cause_short_408: 'Oth Un Inf',
    cause_short_962: 'Mat+Neonat',
    cause_short_366: 'Maternal',
    cause_short_367: 'Mat Hem',
    cause_short_368: 'Mat Sepsis',
    cause_short_369: 'Mat HTN',
    cause_short_370: 'Obst Labor',
    cause_short_995: 'Mat Abort',
    cause_short_374: 'Ectopic Preg',
    cause_short_375: 'Mat Indir',
    cause_short_376: 'Mat Late',
    cause_short_741: 'Mat HIV',
    cause_short_379: 'Oth Mat',
    cause_short_380: 'Neonatal',
    cause_short_381: 'NN Preterm',
    cause_short_382: 'NN Enceph',
    cause_short_383: 'NN Sepsis',
    cause_short_384: 'NN Hemol',
    cause_short_385: 'Oth NN',
    cause_short_386: 'Nutr Def',
    cause_short_387: 'PEM',
    cause_short_388: 'Iodine',
    cause_short_389: 'Vit A',
    cause_short_390: 'Iron',
    cause_short_391: 'Oth Nutr',
    cause_short_409: 'NCD',
    cause_short_410: 'Neoplasms',
    cause_short_444: 'Lip Oral C',
    cause_short_447: 'Nasoph C',
    cause_short_450: 'Oth Phar C',
    cause_short_411: 'Esophag C',
    cause_short_414: 'Stomach C',
    cause_short_441: 'Colorect C',
    cause_short_417: 'Liver C',
    cause_short_418: 'Liver C HepB',
    cause_short_419: 'Liver C HepC',
    cause_short_420: 'Liver C Alc',
    cause_short_996: 'Liver C NASH',
    cause_short_1021: 'Oth Liver C',
    cause_short_453: 'Gallblad C',
    cause_short_456: 'Pancreas C',
    cause_short_423: 'Larynx C',
    cause_short_426: 'Lung C',
    cause_short_459: 'Melanoma',
    cause_short_462: 'Skin C',
    cause_short_849: 'SCC',
    cause_short_850: 'BCC',
    cause_short_429: 'Breast C',
    cause_short_432: 'Cervix C',
    cause_short_435: 'Uterus C',
    cause_short_465: 'Ovary C',
    cause_short_438: 'Prostate C',
    cause_short_468: 'Testis C',
    cause_short_471: 'Kidney C',
    cause_short_474: 'Bladder C',
    cause_short_477: 'Brain C',
    cause_short_480: 'Thyroid C',
    cause_short_483: 'Mesothel',
    cause_short_484: 'Hodgkin',
    cause_short_485: 'Lymphoma',
    cause_short_486: 'Myeloma',
    cause_short_487: 'Leukemia',
    cause_short_845: 'ALL',
    cause_short_846: 'CLL',
    cause_short_847: 'AML',
    cause_short_848: 'CML',
    cause_short_943: 'Oth Leukemia',
    cause_short_1022: 'Other MN',
    cause_short_490: 'Other Neo',
    cause_short_964: 'MDS+MPN',
    cause_short_965: 'Intest NMN',
    cause_short_966: 'Cervix NMN',
    cause_short_967: 'Oth NMN',
    cause_short_491: 'CVD',
    cause_short_492: 'RHD',
    cause_short_493: 'IHD',
    cause_short_494: 'Stroke',
    cause_short_495: 'Isch Stroke',
    cause_short_496: 'Intrahem Stroke',
    cause_short_497: 'Sub Hem',
    cause_short_498: 'HTN HD',
    cause_short_504: 'Valvular',
    cause_short_968: 'CAVD',
    cause_short_969: 'DMVD',
    cause_short_970: 'Oth Valvu',
    cause_short_499: 'CMP',
    cause_short_942: 'Myocarditis',
    cause_short_938: 'Alcohol CMP',
    cause_short_944: 'Oth CMP',
    cause_short_500: 'A Fib',
    cause_short_501: 'Aort An',
    cause_short_502: 'PAD',
    cause_short_503: 'Endocar',
    cause_short_1023: 'Oth Cardio',
    cause_short_508: 'Chr Resp',
    cause_short_509: 'COPD',
    cause_short_510: 'Pneumocon',
    cause_short_511: 'Silicosis',
    cause_short_512: 'Asbestosis',
    cause_short_513: 'Coal W',
    cause_short_514: 'Oth Pneum',
    cause_short_515: 'Asthma',
    cause_short_516: 'ILD',
    cause_short_520: 'Oth Resp',
    cause_short_526: 'Digestive',
    cause_short_521: 'Cirrhosis',
    cause_short_522: 'Cirr HepB',
    cause_short_523: 'Cirr HepC',
    cause_short_524: 'Cirr Alc',
    cause_short_971: 'Cirr Oth NAFLD',
    cause_short_525: 'Oth Cirr',
    cause_short_992: 'Upper Digest',
    cause_short_527: 'PUD',
    cause_short_528: 'Gastritis',
    cause_short_536: 'GERD',
    cause_short_529: 'Appendicit',
    cause_short_530: 'Ileus',
    cause_short_531: 'Hernia',
    cause_short_532: 'IBD',
    cause_short_533: 'Vasc Intest',
    cause_short_534: 'Gall Bile',
    cause_short_535: 'Pancreatit',
    cause_short_541: 'Oth Digest',
    cause_short_542: 'Neuro',
    cause_short_543: "Alzheimer's",
    cause_short_544: "Parkinson's",
    cause_short_545: 'Idiopathic epilepsy',
    cause_short_546: 'MS',
    cause_short_554: 'ALS',
    cause_short_972: 'Headaches',
    cause_short_547: 'Migraine',
    cause_short_548: 'Tens Head',
    cause_short_557: 'Oth Neuro',
    cause_short_558: 'Mental',
    cause_short_559: 'Schiz',
    cause_short_567: 'Depression',
    cause_short_568: 'MDD',
    cause_short_569: 'Dysthymia',
    cause_short_570: 'Bipolar',
    cause_short_571: 'Anxiety',
    cause_short_572: 'Eating',
    cause_short_573: 'Anorexia',
    cause_short_574: 'Bulimia',
    cause_short_575: 'ASD',
    cause_short_578: 'ADHD',
    cause_short_579: 'Conduct',
    cause_short_582: 'ID',
    cause_short_585: 'Oth Ment',
    cause_short_973: 'Subs Use',
    cause_short_560: 'Alcohol',
    cause_short_561: 'Drugs',
    cause_short_562: 'Opioids',
    cause_short_563: 'Cocaine',
    cause_short_564: 'Amphet',
    cause_short_565: 'Cannabis',
    cause_short_566: 'Oth Drug',
    cause_short_974: 'Diabetes+CKD',
    cause_short_587: 'Diabetes',
    cause_short_975: 'Diabetes 1',
    cause_short_976: 'Diabetes 2',
    cause_short_589: 'CKD',
    cause_short_997: 'CKD Diabetes1',
    cause_short_998: 'CKD Diabetes2',
    cause_short_591: 'HTN CKD',
    cause_short_592: 'GN CKD',
    cause_short_593: 'Oth CKD',
    cause_short_588: 'AGN',
    cause_short_653: 'Skin',
    cause_short_654: 'Dermatitis',
    cause_short_977: 'Atopic Derm',
    cause_short_978: 'Contact Derm',
    cause_short_979: 'Seborr Derm',
    cause_short_655: 'Psoriasis',
    cause_short_980: 'Bac Skin',
    cause_short_656: 'Cellulitis',
    cause_short_657: 'Pyoderma',
    cause_short_658: 'Scabies',
    cause_short_659: 'Skin Fung',
    cause_short_660: 'Skin Viral',
    cause_short_661: 'Acne',
    cause_short_662: 'Alopecia',
    cause_short_663: 'Pruritus',
    cause_short_664: 'Urticaria',
    cause_short_665: 'Decubitus',
    cause_short_668: 'Oth Skin',
    cause_short_669: 'Sense',
    cause_short_981: 'Blindness',
    cause_short_670: 'Glaucoma',
    cause_short_671: 'Cataract',
    cause_short_672: 'Macular',
    cause_short_999: 'Refraction',
    cause_short_1000: 'Near vision',
    cause_short_675: 'Oth Vision',
    cause_short_674: 'Hearing',
    cause_short_679: 'Oth Sense',
    cause_short_626: 'MSK',
    cause_short_627: 'Rheu Arth',
    cause_short_628: 'Osteoarth',
    cause_short_1014: 'Osteoarth Hip',
    cause_short_1015: 'Osteoarth Knee',
    cause_short_1016: 'Osteoarth Hand',
    cause_short_1017: 'Osteoarth Oth',
    cause_short_630: 'Back Pain',
    cause_short_631: 'Neck Pain',
    cause_short_632: 'Gout',
    cause_short_639: 'Oth MSK',
    cause_short_640: 'Oth NCD',
    cause_short_641: 'Congenital',
    cause_short_642: 'Neur Tube',
    cause_short_643: 'Cong Heart',
    cause_short_644: 'Cleft',
    cause_short_645: 'Down',
    cause_short_646: 'Turner',
    cause_short_647: 'Klinefelter',
    cause_short_648: 'Chrom Unb',
    cause_short_649: 'Cong MSK',
    cause_short_650: 'Cong Urogen',
    cause_short_651: 'Digest Anom',
    cause_short_652: 'Oth Cong',
    cause_short_594: 'Urinary',
    cause_short_595: 'UTI and interstitial nephritis',
    cause_short_596: 'Urolith',
    cause_short_597: 'BPH',
    cause_short_598: 'Infert M',
    cause_short_602: 'Oth Urin',
    cause_short_603: 'Gyne',
    cause_short_604: 'Fibroids',
    cause_short_605: 'PCOS',
    cause_short_606: 'Infert F',
    cause_short_607: 'Endomet',
    cause_short_608: 'Prolapse',
    cause_short_609: 'PMS',
    cause_short_612: 'Oth Gyne',
    cause_short_613: 'Hemog',
    cause_short_614: 'Thalass',
    cause_short_837: 'Thalass Trait',
    cause_short_615: 'Sickle',
    cause_short_838: 'Sickle Trait',
    cause_short_616: 'G6PD',
    cause_short_839: 'G6PD Trait',
    cause_short_618: 'Oth Hem',
    cause_short_619: 'Endocrine',
    cause_short_680: 'Oral',
    cause_short_681: 'Dec Caries',
    cause_short_682: 'Per Caries',
    cause_short_683: 'Period',
    cause_short_684: 'Edentul',
    cause_short_685: 'Other Oral',
    cause_short_686: 'SIDS',
    cause_short_687: 'Injuries',
    cause_short_688: 'Trans Inj',
    cause_short_689: 'Road Inj',
    cause_short_690: 'Pedest',
    cause_short_691: 'Cyclist',
    cause_short_692: 'Mot Cyc',
    cause_short_693: 'Mot Veh',
    cause_short_694: 'Oth Road',
    cause_short_695: 'Oth Trans',
    cause_short_696: 'Unint Inj',
    cause_short_697: 'Falls',
    cause_short_698: 'Drown',
    cause_short_699: 'Fire',
    cause_short_700: 'Poison',
    cause_short_701: 'Inj Pois CO',
    cause_short_703: 'Inj Pois Oth',
    cause_short_704: 'Mech',
    cause_short_705: 'Mech Gun',
    cause_short_707: 'Oth Mech',
    cause_short_708: 'Med Treat',
    cause_short_709: 'Animal',
    cause_short_710: 'Venom',
    cause_short_711: 'Non Ven',
    cause_short_712: 'F Body',
    cause_short_713: 'F Body Asp',
    cause_short_714: 'F Body Eye',
    cause_short_715: 'Oth F Body',
    cause_short_842: 'Heat + cold',
    cause_short_729: 'Disaster',
    cause_short_716: 'Oth Unint',
    cause_short_717: 'Self-harm & IPV',
    cause_short_718: 'Self Harm',
    cause_short_721: 'Self Fire',
    cause_short_723: 'Self Other',
    cause_short_724: 'Violence',
    cause_short_725: 'Viol Gun',
    cause_short_726: 'Viol Knife',
    cause_short_941: 'Sex Viol',
    cause_short_727: 'Oth Viol',
    cause_short_945: 'Conflict Terror',
    cause_short_854: 'Exec & Police',
    cause_short_1029: 'Tot Cancer',
    cause_short_1026: 'Tot Hep B',
    cause_short_1027: 'Tot Hep C',
    cause_short_1028: 'Tot NAFLD',
};
